function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clip-logo_3);\n      }\n\n      .cls-2 {\n        fill: #505762;\n      }\n\n      .cls-3 {\n        fill: #5fc5d1;\n      }\n\n      .cls-4 {\n        fill: #6bd5e1;\n      }\n\n      .cls-5 {\n        fill: #ffc78e;\n      }\n\n      .cls-6 {\n        fill: none;\n        stroke: #ffd98e;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 11px;\n      }\n\n      .cls-7 {\n        fill: #ffd98e;\n      }\n\n      .cls-8 {\n        fill: #e49d75;\n      }\n\n      .cls-9 {\n        fill: #e0e0e0;\n      }\n\n      .cls-10 {\n        fill: #ffe4ad;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-logo_3"
}, /*#__PURE__*/React.createElement("rect", {
  width: 223,
  height: 262
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "logo_3",
  "data-name": "logo \\u2013 3",
  className: "cls-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2",
  transform: "translate(18.957 12.971)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_68",
  "data-name": "Path 68",
  className: "cls-2",
  d: "M164.375,167.5c9.174,17.261-3.188,45.964-10.524,74.907s-9.727,57.967-27.031,72.677c-17.3,14.753-49.553,15.111-75.905,2.632S4.11,280,.6,253.886s9.848-53.036,28.187-72.356A109,109,0,0,1,97.4,147.484C124.446,144.534,155.167,150.273,164.375,167.5Z",
  transform: "translate(0 -104.676)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_69",
  "data-name": "Path 69",
  className: "cls-3",
  d: "M494.69,12.248,439.01,24.194V12.534L494.46.64l8.251,4.295Z",
  transform: "translate(-313.122 -0.457)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_70",
  "data-name": "Path 70",
  className: "cls-3",
  d: "M280.518,12.078,224.219,0l-7.4,4.257,6.754,7.265,56.944,12.216Z",
  transform: "translate(-154.63)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_71",
  "data-name": "Path 71",
  className: "cls-4",
  d: "M56.28,644.53c-.287,3.971-2.007,21.908-.831,27.438h51.03l-5.249-26.515Z",
  transform: "translate(-39.232 -459.754)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_72",
  "data-name": "Path 72",
  className: "cls-5",
  d: "M168.9,432.395c6.373-4.257,21.828,12.749,22.528,17.8-1.56,2.58-12.557,10.206-16.6,9.782C170.539,456.525,162.746,436.5,168.9,432.395Z",
  transform: "translate(-118.822 -307.951)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_19",
  "data-name": "Line 19",
  className: "cls-6",
  y2: 229.453,
  transform: "translate(125.888 5.246)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_73",
  "data-name": "Path 73",
  className: "cls-7",
  d: "M73.041,405.53c36.718,0,31.082,60.433,28.731,70.773-9.352,5.255-39.319,4.521-47.988-1.052C50.462,457.984,50.069,405.53,73.041,405.53Z",
  transform: "translate(-37.155 -289.271)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_74",
  "data-name": "Path 74",
  className: "cls-8",
  d: "M20.554,511.57c-1.026,3.44-4.567,30.675.86,34.786s25.552-10.825,29.144-13.9-.72-8.156-4.541-7.081-11.915,3.9-13.405,4.825c1.433-3.285,4.1-12.416,4.077-14.93S20.554,511.57,20.554,511.57Z",
  transform: "translate(-13.144 -364.912)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_75",
  "data-name": "Path 75",
  className: "cls-9",
  d: "M205.1,475.77,131.57,495.835v-55.8L205.1,419.97Z",
  transform: "translate(-93.82 -299.572)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_76",
  "data-name": "Path 76",
  className: "cls-4",
  d: "M280.518,54.439,224.761,66.4l-7.941-4.183,5.742-7L280.518,42.78Z",
  transform: "translate(-154.63 -30.516)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_77",
  "data-name": "Path 77",
  className: "cls-4",
  d: "M495.458,54.889,439.01,42.78V54.439L494.77,66.4l7.941-4.4Z",
  transform: "translate(-313.122 -30.516)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_2",
  "data-name": "Ellipse 2",
  cx: 14.133,
  cy: 14.133,
  r: 14.133,
  transform: "translate(5.839 65.031)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_3",
  "data-name": "Ellipse 3",
  className: "cls-8",
  cx: 16.628,
  cy: 16.628,
  r: 16.628,
  transform: "translate(23.545 79.838)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_78",
  "data-name": "Path 78",
  d: "M87.447,307.4c10.607-8.363,12.961-21.619,13.256-28.78a17.219,17.219,0,0,0-2.05-.129A16.628,16.628,0,0,0,87.447,307.4Z",
  transform: "translate(-58.481 -198.652)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_79",
  "data-name": "Path 79",
  d: "M137.154,285.683a19.9,19.9,0,0,0,3.839-.373,16.645,16.645,0,0,0-18.443-6.057A19.753,19.753,0,0,0,137.154,285.683Z",
  transform: "translate(-87.386 -198.646)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_80",
  "data-name": "Path 80",
  className: "cls-8",
  d: "M124.33,385.683c0,2.164-11.82,2.119-11.82,0V370.11h11.82Z",
  transform: "translate(-80.224 -264.006)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_81",
  "data-name": "Path 81",
  className: "cls-10",
  d: "M34.84,428.718c7.554,1.3,7.058,24.271,4.085,28.419-2.91.806-16.132-1.238-18.778-4.332C19.422,447.356,27.552,427.463,34.84,428.718Z",
  transform: "translate(-14.308 -305.772)"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_4",
  "data-name": "Ellipse 4",
  className: "cls-8",
  cx: 6.955,
  cy: 8.231,
  rx: 6.955,
  ry: 8.231,
  transform: "translate(32.288 151.544)"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_5",
  "data-name": "Ellipse 5",
  className: "cls-8",
  cx: 4.074,
  cy: 6.728,
  rx: 4.074,
  ry: 6.728,
  transform: "translate(105.828 136.785)"
})));

var SvgDirectionsColour = function SvgDirectionsColour(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "",
    height: 300,
    viewBox: "0 0 223 262",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDirectionsColour, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/directions-colour.f1a6f5f8.svg";
export { ForwardRef as ReactComponent };